import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "mediaContainer"]
  static values = {
    currentIndex: Number
  }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  open(event) {
    event.preventDefault()
    
    // Get media information from data attributes
    const clickedElement = event.currentTarget
    const mediaUrl = clickedElement.dataset.mediaModalUrlParam
    const mediaType = clickedElement.dataset.mediaModalTypeParam
    
    if (!mediaUrl) return
    
    // Find all available media items and set current index
    this.mediaItems = Array.from(document.querySelectorAll("[data-media-modal-url-param]"))
    this.currentIndexValue = this.mediaItems.indexOf(clickedElement)
    
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.loadMedia(mediaUrl, mediaType)
  }

  loadMedia(mediaUrl, mediaType) {
    this.mediaContainerTarget.innerHTML = ""
    
    if (mediaType === "video") {
      const video = document.createElement("video")
      video.src = mediaUrl
      video.controls = true
      video.autoplay = true
      video.classList.add("max-h-[90vh]", "max-w-full", "object-contain")
      this.mediaContainerTarget.appendChild(video)
    } else if (mediaType === "animation") {
      const img = document.createElement("img")
      img.src = mediaUrl
      img.classList.add("max-h-[90vh]", "max-w-full", "object-contain")
      this.mediaContainerTarget.appendChild(img)
    } else {
      const img = document.createElement("img")
      img.src = mediaUrl
      img.classList.add("max-h-[90vh]", "max-w-full", "object-contain")
      this.mediaContainerTarget.appendChild(img)
    }
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.mediaContainerTarget.innerHTML = ""
  }

  handleKeydown(event) {
    if (!this.modalTarget.classList.contains("hidden")) {
      switch(event.key) {
        case "Escape":
          this.close()
          break
        case "ArrowLeft":
          this.navigate("prev")
          break
        case "ArrowRight":
          this.navigate("next")
          break
      }
    }
  }

  navigate(event) {
    const direction = event.currentTarget?.dataset.mediaModalDirectionParam || event
    const totalItems = this.mediaItems.length
    let newIndex

    if (direction === "next") {
      newIndex = (this.currentIndexValue + 1) % totalItems
    } else {
      newIndex = (this.currentIndexValue - 1 + totalItems) % totalItems
    }

    const nextItem = this.mediaItems[newIndex]
    this.currentIndexValue = newIndex
    this.loadMedia(
      nextItem.dataset.mediaModalUrlParam,
      nextItem.dataset.mediaModalTypeParam
    )
  }

  closeBackground(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
} 